import React from 'react';
import work1 from '../../../src/assets/images/work-1.png';
import git from '../../../src/assets//images/github.svg';
import link from '../../../src/assets/images/link.svg';
import quato from '../../../src/assets/images/work-2.png';
import medi from '../../../src/assets/images/work-3.png';
import edu from '../../../src/assets/images/work-4.png';
import mac from '../../../src/assets/images/work-5.png';
import honda from '../../../src/assets/images/work-6.png';
import Footer from '../Shared/Footer/Footer';
import Navbar from '../Shared/Navbar/Navbar';
import { Link } from 'react-router-dom';

const Works = () => {
    return (
        <div>
            <Navbar />
            <div style={{ marginTop: '100px' }} className='container'>
                <h2 className='title'>My Recent Works</h2>
                <h1 className='title-bg'>WEB APPS</h1>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={work1} alt="" />
                            <h3 className='work-name'>Jetaway Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/jetaway'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/jetaway-app-client-side" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://jetaway.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={quato} alt="" />
                            <h3 className='work-name'>Quato Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/quato'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/quato-app-client-side" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://quato.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={medi} alt="" />
                            <h3 className='work-name'>Medisure Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/medisure'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/medisure-app" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://medisure.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={edu} alt="" />
                            <h3 className='work-name'>Educapedia Web Application</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/educapedia'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/educapedia-app" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://educapediaa.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={mac} alt="" />
                            <h3 className='work-name'>Macbook Pro Site</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/macbook'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/mac-book-pro" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://macbookpro.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-4'>
                        <div className='work-card'>
                            <img src={honda} alt="" />
                            <h3 className='work-name'>Honda CBR Site</h3>
                            <div className='d-flex justify-content-between align-items-center'>
                                <Link to='/honda'><button className='work-btn'>Details</button></Link>
                                <div className='me-4'>
                                    <a className='me-3' href="https://github.com/mishrahat/honda-crb" target='_blank'><img style={{ width: '30px' }} src={git} alt="" /></a>
                                    <a href="https://honda-cbrrr.netlify.app/" target='_blank'><img style={{ width: '30px' }} src={link} alt="" /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Works;